<div class="filter-for-list" *ngIf="!readOnly">
    <mat-form-field class="mini-list-header" placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput [value]="projectLocations ? projectLocations.filter : null"
               (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
    </mat-form-field>
    <mat-slide-toggle (click)="activeOrInactiveLocation()">{{getActiveTextForSlider()}}</mat-slide-toggle>
    <button type="button" class="btn top-list-tools" (click)="addLocation()" placement="left"
            [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
        <fa-icon [icon]="faPlus"></fa-icon>
        {{'ADD_LOCATION'|translate}}
    </button>

    <form [formGroup]="locationForm" style="float:right;" *ngIf="parentLocations">
        <mat-form-field class="mini-list-header">
            <input matInput [placeholder]="'NAME' | translate" formControlName="name" [readonly]="false">
        </mat-form-field>

        <mat-form-field class="mini-list-header">
            <mat-select [placeholder]="'PARENT' | translate" formControlName="parent">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let location of parentLocations" [value]="location.id">
                    {{location.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>


    </form>
    <div style="float:right">

        <mat-form-field class="mini-list-header">
            <input matInput [value]="('LOCATION_COUNT'|translate) + ' : ' + countLocations" [disabled]="true"/>
        </mat-form-field>


        <mat-slide-toggle class="sliderActiveList" (change)="changeLockerValue()" ngModel="readModeForLocationName"
                          placement="left"
                          [ngbTooltip]="'UNLOCK_SLIDER_TOOLTIP' | translate">
            <mat-icon style="color:gray;cursor:pointer" [innerHtml]="readModeForLocationName ? 'lock_open' : 'lock'">
            </mat-icon>
        </mat-slide-toggle>

    </div>

    <br clear="both"/>
</div>
<div *ngIf="readOnly" class="header">
    <b [innerHtml]="'LOCATION'|translate">Information</b>
    <app-button-project-edit [selectedStep]="5"></app-button-project-edit>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<table mat-table [dataSource]="projectLocations" matSort class="table-striped" style="width:100%" matSortActive="id"
       matSortDirection="desc">


    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let location">{{location.id}}
        </td>
    </ng-container>

    <ng-container matColumnDef="parentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:14%">{{'PARENT'|translate}}</th>
        <td mat-cell *matCellDef="let location">

            <b *ngIf="readModeForLocationName">{{location.parentName}}</b>
            <mat-form-field class="mini-list-header"
                            *ngIf="location.children.length === 0 && !readModeForLocationName"
                            matTooltipPosition="right"
                            [matTooltip]="'CHANGE_PARENT_TOOLTIP'|translate">
                <!--<mat-select [(value)]="location.parentId" [placeholder]="'PARENT' | translate">-->
                <mat-select [(value)]="location.parentId"
                            (selectionChange)="changeParent(location, $event.value)"
                            [disabled]="showSpinner">
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngFor="let loca of getParentLocations(location)" [value]="loca.id">
                        {{loca.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <fa-icon [icon]="faSpinner" pulse="true" *ngIf="location.locationParentPending"></fa-icon>
        </td>
    </ng-container>


    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:14%">{{'NAME'|translate}}</th>
        <td mat-cell *matCellDef="let location;let i = index;">
            <b *ngIf="readModeForLocationName">{{location.name}}</b>
            <mat-form-field *ngIf="!readModeForLocationName" class="mini-list-header">
                <input matInput [(ngModel)]="location.name"
                       (focus)="focusedName = location.name"
                       (blur)="changeLocationName(location,location.name)"
                       [disabled]="showSpinner"/>
            </mat-form-field>
            <fa-icon [icon]="faSpinner" pulse="true" *ngIf="location.locationNamePending"></fa-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="deviceType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:10%">{{'TYPE'|translate}}</th>
        <td mat-cell *matCellDef="let location">

            <mat-chip-list *ngIf="location.deviceType" style="display:inline-block;">
                <mat-chip>
                    <span>{{location.deviceType|translate}} </span>
                    <span class="inner-badge" *ngIf="getUnitByPriority(location)">{{getUnitByPriority(location)}}</span>
                    <span class="inner-badge-length"
                          *ngIf="getLengthByPriority(location)">{{getLengthByPriority(location)}}</span>
                </mat-chip>

            </mat-chip-list>

            <mat-chip-list *ngIf="!location.deviceType && !location.parentName" style="display:inline-block;">

                <mat-chip style="background-color: yellowgreen;color:#fff">{{'LOCATION_GROUP'|translate}}</mat-chip>
            </mat-chip-list>

        </td>
    </ng-container>

    <ng-container matColumnDef="deviceAssignedUid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE_ASSIGNED'|translate}}</th>
        <td mat-cell *matCellDef="let location">

                                    <span *ngIf="location.deviceAssigned?.parent?.parent" style="display: inline-block">

                 <mat-chip-list style="display: inline-block">
                        <mat-chip matBadgePosition="below after" matBadgeColor="accent"
                                  [matBadge]="location.deviceAssigned.parent.parent.channel">{{location.deviceAssigned.parent.parent.device_type.type|translate}}
                                                    </mat-chip>
                    </mat-chip-list>
                    <span class="linkInList">{{location.deviceAssigned.parent.parent.uid}} </span>
   <mat-icon class="arrow-parent">play_arrow
            </mat-icon>

            </span>

            <span *ngIf="location.deviceAssigned?.parent" style="display: inline-block">

                 <mat-chip-list style="display: inline-block">
                        <mat-chip matBadgePosition="below after" matBadgeColor="accent"
                                  [matBadge]="location.deviceAssigned.parent.channel">{{location.deviceAssigned.parent.device_type.type|translate}}
                                                    </mat-chip>
                    </mat-chip-list>
                    <span class="linkInList">{{location.deviceAssigned.parent.uid}} </span>
   <mat-icon class="arrow-parent">play_arrow
            </mat-icon>

            </span>


            <mat-chip-list *ngIf="location.deviceAssigned" style="display:inline-block;">
                <mat-chip matBadgePosition="below after" matBadgeColor="accent"
                          [matBadge]="location.deviceAssigned.channel"
                          [removable]="true">
                    <span>{{location.deviceType|translate}}</span>
                    <span class="inner-badge"
                          *ngIf="getUnitByPriority(location,true)">{{getUnitByPriority(location, true)}}</span>
                    <span class="inner-badge-length"
                          *ngIf="getLengthByPriority(location,true)">{{getLengthByPriority(location, true)}}</span>
                    <mat-icon *ngIf="location.deviceAssigned && !readModeForLocationName" matChipRemove
                              (click)="deleteDeviceLocation(location.id) "
                              style="color:red"
                              matTooltipPosition="right" [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
                    </mat-icon>
                </mat-chip>

            </mat-chip-list>
            <app-device-crud *ngIf="location.deviceAssigned" [deviceId]="location.deviceAssigned.id" [mode]="'update'"
                             [displayLink]="location.deviceAssigned.uid" [deviceType]="deviceTypes"
                             [unitList]="unitList"></app-device-crud>
            <span *ngIf="deviceCanBeAdded(location) && !readModeForLocationName"><button style="transform:scale(.8)"
                                                                                         class="btn btn-info"
                                                                                         (click)="openModal(location)">
                <fa-icon [icon]="faPlus"></fa-icon>&nbsp;{{'DEVICE_ASSIGNEMENT'|translate}}</button></span>

        </td>
    </ng-container>

    <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'UNIT'|translate}}</th>
        <td mat-cell *matCellDef="let location"><span *ngIf="location.unit"
                                                      [innerHtml]="location.unit|translate"></span>
        </td>
    </ng-container>

    <ng-container matColumnDef="length">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LENGTH'|translate}}</th>
        <td mat-cell *matCellDef="let location"><b>{{location.length}}</b>
        </td>
    </ng-container>

    <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ACTIVE'|translate}}</th>
        <td mat-cell *matCellDef="let location">
            <fa-icon *ngIf="location.active === true" [icon]="faSmile" style="color:green;font-size: 25px;"></fa-icon>
            <fa-icon *ngIf="location.active === false" [icon]="faSadTear" style="color:red;font-size: 25px;"></fa-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="width:5%">{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let location">

            <mat-icon style="color:red;cursor:pointer"
                      *ngIf="isDeletable(location) && !readModeForLocationName && locationToDelete === null"
                      matTooltipPosition="right" (click)="confirmDeleteLocation(location.id)"
                      [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
            </mat-icon>


            <div *ngIf="isDeletable(location) && !readModeForLocationName && locationToDelete === location.id"
                 style="background: #343a40">
                <button [matTooltip]="'DELETE_ICON_TOOLTIP'|translate" matTooltipPosition="right" type="button"
                        class="btn btn-warning" style="transform: scale(.7)"
                        (click)="deleteLocation(location.id)">
                    <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
                    <mat-icon style="color:red;display: inline">cancel
                    </mat-icon>
                    {{'DELETE'|translate}}
                </button>
                <button [matTooltip]="'CANCEL'|translate" matTooltipPosition="right" (click)="locationToDelete = null"
                        style="transform: scale(.7)"
                        class="btn btn-primary">
                    <mat-icon style="color:white;display: inline">undo
                    </mat-icon>
                    {{'CANCEL'|translate}}</button>
            </div>

        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>

</table>

<mat-paginator *ngIf="!readOnly" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
               [pageSize]="5"></mat-paginator>
